import { Injectable, ErrorHandler, ClassProvider } from '@angular/core';
import { IAutoExceptionTelemetry, IExceptionTelemetry } from '@microsoft/applicationinsights-web';
import { Observable, Subject } from 'rxjs';
import { AppInsightsRef } from './app-insights-ref';

/**
 * register this handler to ensure Errors all global errors get recorded
 */
@Injectable()
export class AppInsightsErrorHandler extends ErrorHandler {
  private handledErrorSubject = new Subject<any>();

  readonly handledError$: Observable<Error | ErrorEvent> = this.handledErrorSubject.asObservable();

  constructor(private appInsightsRef: AppInsightsRef) {
    super();
  }

  handleError(error: any): void {
    super.handleError(error);
    try {
      if (error instanceof Error) {
        this.appInsightsRef.appInsights?.trackException({ exception: error });
      }
      else if (error instanceof ErrorEvent && error.error) {
        const telem: IExceptionTelemetry = {
          exception: {
            columnNumber: error.colno,
            error: error.error,
            errorSrc: error.target ? `${error.target}` : undefined,
            evt: error.type,
            lineNumber: error.lineno,
            message: error.message || error.error?.message,
            name: error.error?.name,
            stack: error.error?.stack,
            url: window.location.toString()
          }
        }
        this.appInsightsRef.appInsights?.trackException(telem);
      }
      else if (typeof error === 'string') {
        // convert a string to an error.
        error = new Error(error);
        this.appInsightsRef.appInsights?.trackException({ exception: error });
      }
      else {
        // don't know what this is.
        error = new Error(error?.message ?? error?.title);
        this.appInsightsRef.appInsights?.trackException({ exception: error });
      }
      this.handledErrorSubject.next(error);
    } catch (err) {
      console.error('Unable to log error');
      console.error(err);
    }
  }
}

/** Use this to provider app insights error handler */
export const AppInsightsErrorHandlerProvider: ClassProvider = {
  provide: ErrorHandler,
  useClass: AppInsightsErrorHandler
};
